

































































































































import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import BulkSchemaCreate from "@/components/BulkSchemaCreate.vue";
import BulkSchemaMapping from "@/components/BulkSchemaMapping.vue";
import CompaniesSwitcher from "@/components/CompaniesSwitcher.vue";
import errorsUtil from "../utils/errorMappings";
import _ from "lodash";
@Component({
  components: {
    BulkSchemaCreate,
    BulkSchemaMapping,
    CompaniesSwitcher,
  },
})
export default class BulkSchema extends Vue {
  @Provide("$api") $api: any;
  @Provide("$_") $_: any;

  @Prop() private companyId!: string;
  @Prop() private accountId!: string;

  private errorMessageTop = "";

  currentStep = 0;
  loading = true;
  data = null;
  fieldMapping: any = null;
  fileType = "";
  fileSeparator = "";
  hasFileHeader = true;

  mounted() {
    this.getSchemaAndMappings();
  }

  async nextStep() {
    this.currentStep = this.currentStep + 1;
  }

  async previousStep() {
    await this.getSchemaAndMappings();
    this.currentStep = this.currentStep - 1;
  }

  async gotoStep(step) {
    await this.getSchemaAndMappings();
    this.currentStep = step;
  }

  private setSchemaData(schemaData) {
    this.data = schemaData;
  }

  private displayError(error) {
    const errorCode = error.response.data.code;
    if (_.has(errorsUtil.errorMessages, errorCode)) {
      this.$store.commit("recordError", "");
      this.errorMessageTop = errorsUtil.errorMessages[errorCode];
    }
  }

  companySwitched(event) {
    const params = Object.assign({}, this.$route.params, {
      companyId: event.companyId,
    });
    this.$router.push({ name: "schema_list", params: params });
    location.reload();
  }

  getFileType(delimiter: string) {
    if (delimiter == ",") {
      return "CSV";
    } else if (delimiter == "|") {
      return "PSV";
    } else if (delimiter == "/t") {
      return "TSV";
    } else {
      return "Other";
    }
  }

  private fieldMappingKeys() {
    return this.fieldMapping ? Object.keys(this.fieldMapping) : [];
  }

  private formatFieldMapping(mapping) {
    if (mapping.fields.length == 1) {
      return mapping.fields[0];
    } else {
      return mapping.joinType == "concat"
        ? mapping.fields.join(mapping.delimiter) + " (concatenated)"
        : mapping.fields.join(" or ") + " (coalesced)";
    }
  }

  async getSchemaAndMappings() {
    this.$store.commit("startLoading");
    this.loading = true;
    try {
      const response = await this.$api.get(
        `item-classification-api/v1/company/${this.companyId}/defaultSchema`
      );
      const mappingResponse = await this.$api.get(
        `item-classification-api/v1/company/${this.companyId}/defaultMapping`
      );
      this.data = response.data;
      this.fieldMapping = mappingResponse.data;
      if (this.data) {
        this.fileType = this.getFileType(response.data.schema.delimiter);
        this.fileSeparator = response.data.schema.delimiter;
        this.hasFileHeader = response.data.schema.hasHeader;
      }
      this.$store.commit("stopLoading");
      this.loading = false;
    } catch (error) {
      if ((error as any).response.status === 404) {
        this.$store.commit("recordError", "");
      } else {
        this.displayError(error);
      }
      this.$store.commit("stopLoading");
      this.loading = false;
    }
  }
}
